var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "form" }, [
      _c("div", { staticClass: "labeled-field" }, [
        _c("label", { attrs: { for: "textarea-1" } }, [
          _vm._v("\n        Name\n        "),
          _c("span", { domProps: { innerHTML: _vm._s(_vm.nameLength) } }),
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.newWishlistName,
              expression: "newWishlistName",
            },
          ],
          staticClass: "form-control form-control-lg",
          attrs: {
            id: "new-wishlistname",
            type: "text",
            name: "wishlistname",
            disabled: _vm.creationDisabled,
            placeholder: "Neue Wunschliste",
          },
          domProps: { value: _vm.newWishlistName },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) return
                _vm.newWishlistName = $event.target.value
              },
              _vm.checkNameLength,
            ],
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.createWishlist()
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn form-control btn-bkm mb-2",
          attrs: { disabled: _vm.creationDisabled },
          on: {
            click: function ($event) {
              return _vm.createWishlist()
            },
          },
        },
        [_vm._v("\n      Anlegen\n    ")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }